/**
 * Map a stored DecisionCard option value (often an opaque sentinel) to its
 * human-readable label by scanning preceding assistant messages for a matching
 * `options` entry.
 *
 * Adjacency is not required: retry / server echo can insert extra user turns
 * between the card and the bubble that still carries the option value.
 */
export function resolveDecisionOptionLabel(
  messages: Array<{
    role: string;
    options?: Array<{ label: string; value: string }> | null;
  }>,
  messageIndex: number,
  content: string,
): string | null {
  for (let i = messageIndex - 1; i >= 0; i -= 1) {
    const candidate = messages[i];
    if (
      candidate.role !== "assistant" ||
      !Array.isArray(candidate.options) ||
      candidate.options.length === 0
    ) {
      continue;
    }
    const match = candidate.options.find((option) => option.value === content);
    if (match) {
      return match.label;
    }
  }
  return null;
}
